import * as moment from 'moment';

const regexFloat = /(\d)(?=(\d{3})+\.)/g;
const regexNumeric = /(\d)(?=(\d{3})+(,|$))/g;

const applyRegex = (val, regex, dec = 0) => {
  let value = val;
  if (typeof val === 'string') value = parseInt(val, 10);
  return value.toFixed(dec).replace(regex, '$1,');
};

// Percentage
export const formatPct = (val, dec = 3) => {
  if (!val) return '0.'.concat('0'.repeat(dec), '%');
  const num = Number((val).toFixed(dec));
  if (num === 0) return '0.'.concat('0'.repeat(dec), '%');
  return `${applyRegex(num, regexFloat, dec)}%`;
};

export const formatMoney = (val, dec = 3) => {
  if (!val) return '$0.'.concat('0'.repeat(dec));
  const num = Number((parseFloat(val)).toFixed(dec));
  const sign = (Math.sign(num) < 0) ? '-' : '';
  const newNum = Math.abs(num);
  if (num === 0) return '$0.'.concat('0'.repeat(dec));
  return `${sign}$${applyRegex(newNum, regexFloat, dec)}`;
};

export const formatNumeric = (val, def = 'NA') => {
  if (val === null || val === undefined) return def || 'NA';
  if (val) return applyRegex(val, regexNumeric);
  return 0;
};

export const formatNumericFloat = (val, dec = 2) => {
  if (val === null || val === undefined) return 'NA';
  if (val) {
    const floatVal = parseFloat(val);
    return applyRegex(floatVal, regexFloat, dec);
  }
  return 0;
};

export const formatAbbreviate = (val, fixed = 2) => {
  let num = val;
  if (num === null || num === undefined) return null;
  if (num === 0) return '0';
  if (typeof num === 'string') num = parseInt(num, 10);
  const suffixes = ['', 'K', 'M', 'B', 'T'];
  const newNum = num.toPrecision(2).split('e');
  const suffixNum = newNum.length === 1 ? 0 : Math.floor(Math.min(newNum[1].slice(1), 14) / 3);
  const shortValue = suffixNum < 1 ? num.toFixed(0 + fixed)
    : (num / (1000 ** suffixNum)).toFixed(fixed);
  return shortValue < 0 ? shortValue + suffixes[suffixNum]
    : Math.abs(shortValue) + suffixes[suffixNum];
};

export const formatTruncate = (num) => {
  if (num === null) return null;
  if (num === 0) return '0';
  const suffixes = ['', 'K', 'M', 'B', 'T'];
  const newNum = (num).toPrecision(2).split('e');
  const suffixNum = newNum.length === 1 ? 0 : Math.floor(Math.min(newNum[1].slice(1), 14) / 3);
  const regex = /(\d*.\d{0,2})/;
  const shortValue = suffixNum < 1 ? num.toFixed(0 + 2)
    : (num / (1000 ** suffixNum)).toString().match(regex)[0];
  return shortValue < 0 ? shortValue + suffixes[suffixNum]
    : Math.abs(shortValue) + suffixes[suffixNum];
};

export const formatDate = (val, separator = '/', yLength = 4, wTime = false) => {
  if (!val || val === 'NA') return 'Not available';
  const date = moment.utc(val, ['MM/DD/YYYY', moment.ISO_8601, 'YYYY/MM/DD']);
  // date
  let day = date.date();
  day = day < 10 ? `0${day}` : day;
  let month = date.month() + 1;
  month = month < 10 ? `0${month}` : month;
  const year = date.year().toString().substr(-yLength);
  // time
  let hours = date.hours();
  hours = hours < 10 ? `0${hours}` : hours;
  let minutes = date.minutes();
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  let seconds = date.seconds();
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  const time = wTime ? ` ${hours}:${minutes}:${seconds}` : '';
  return `${month}${separator}${day}${separator}${year}${time}`;
};

export const formatDateCustom = (date, format) => {
  if (!date || date === 'NA') return 'Not available';
  return moment.utc(date).format(format);
};

export default {
  formatPct,
  formatMoney,
  formatNumeric,
  formatNumericFloat,
  formatAbbreviate,
  formatTruncate,
  formatDate,
  formatDateCustom,
};
